<div style="width:100%;height:150px;background-color:#6FCFEB;z-index:9999 !important;">
    <div style="margin-top:40px;height:30px;">
        <span class="d-flex justify-content-center align-items-center">
            <span class="ace-secondary-text-14pt-semi" style="font-size:36px;font-weight: bold !important;color: white;">{{displayMainMessage}}</span>
           
        </span>
        
    </div>

    <div style="width:80%;margin-left:auto;margin-right:auto;margin-top:15px;">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    @if(displaySubMessage.length > 0){
        <div style="margin-top:15px;">
            <span class="d-flex justify-content-center align-items-center">
            <span class="ace-secondary-text-14pt-semi" style="font-size:24px;font-weight: bold !important;color: white;">{{displaySubMessage}}</span>
            </span>
        </div>
    }
<!-- <mat-dialog-actions>
  <button mat-button mat-dialog-close>No</button>
  <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions> -->
</div>